import React, { useEffect } from 'react';
import { FaLaptop, FaBullhorn } from 'react-icons/fa';
import { PiStudentFill } from "react-icons/pi";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Services = () => {

  useEffect(() => {
    AOS.init({
      duration: 1400,
      easing: 'ease-in-cubic',
      once: true,
      offset: 80,
    });
  }, []);


  const handleScroll = (scrollDistance) => {
    window.scrollBy({
      top: scrollDistance,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div>
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-10 mx-auto">

          <div className="text-center mb-20">
            <h2
              data-aos="fade-up"
              data-aos-delay="200"
              className="title-font sm:text-4xl text-3xl mb-6 font-semibold text-gray-900"
            >
              What we do?
            </h2>

            <p
              data-aos="fade-up"
              data-aos-delay="400"
              className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-700"
            >
              At <span className="text-lg text-[#d09714]">EZ Technologies</span>, we are providing <span className="text-lg text-[#d09714]">digital skills</span> training, custom <span className="text-lg text-[#d09714]">software development</span>, and <span className="text-lg text-[#d09714]">digital marketing</span>. We empower individuals and businesses with the tools they need to succeed in the digital world, creating tailored solutions to enhance growth and visibility.
            </p>

            <div
              data-aos="zoom-in"
              data-aos-delay="600"
              className="flex mt-6 justify-center"
            >
              <div className="w-16 h-1 rounded-full bg-[#d09714] inline-flex"></div>
            </div>
          </div>

          {/* Service sections */}
          <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">

            {/* Card 1 */}
            <div
              data-aos="fade-up"
              data-aos-delay="200"
              id="digitalSkills"
              className="p-4 md:w-1/3 flex flex-col text-center items-center"
            >
              <div
                data-aos="zoom-in"
                data-aos-delay="300"
                className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-[#f9e4b2] text-[#d09714] mb-5 flex-shrink-0 transition-all duration-300 transform hover:scale-110 hover:bg-[#f3d284]"
              >
                <PiStudentFill className="w-10 h-10 text-[#d09714]" />
              </div>

              <div className="flex-grow">
                <h2 data-aos="fade-up" data-aos-delay="400" className="text-[#d09714] text-lg title-font font-medium mb-3">
                  Digital Skills
                </h2>

                <p data-aos="fade-up" data-aos-delay="500" className="leading-relaxed text-base">
                  We offer comprehensive training programs to help you master the digital tools.
                </p>

                <button
                  data-aos="fade-up"
                  data-aos-delay="600"
                  className="mt-3 text-[#d09714] inline-flex items-center"
                  onClick={() => handleScroll(400)}
                >
                  Discover More
                </button>
              </div>
            </div>

            {/* Card 2 */}
            <div
              data-aos="fade-up"
              data-aos-delay="400"
              id="customDevelopment"
              className="p-4 md:w-1/3 flex flex-col text-center items-center"
            >
              <div
                data-aos="zoom-in"
                data-aos-delay="500"
                className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-[#f9e4b2] text-[#d09714] mb-5 flex-shrink-0 transition-all duration-300 transform hover:scale-110 hover:bg-[#f3d284]"
              >
                <FaLaptop className="w-10 h-10 text-[#d09714]" />
              </div>

              <div className="flex-grow">
                <h2 data-aos="fade-up" data-aos-delay="600" className="text-[#d09714] text-lg title-font font-medium mb-3">
                  Custom Development
                </h2>

                <p data-aos="fade-up" data-aos-delay="700" className="leading-relaxed text-base">
                  We create tailored software solutions that meet your business's unique needs.
                </p>

                <button
                  data-aos="fade-up"
                  data-aos-delay="800"
                  className="mt-3 text-[#d09714] inline-flex items-center"
                  onClick={() => handleScroll(5000)}
                >
                  Discover More
                </button>
              </div>
            </div>

            {/* Card 3 */}
            <div
              data-aos="fade-up"
              data-aos-delay="600"
              id="digitalMarketing"
              className="p-4 md:w-1/3 flex flex-col text-center items-center"
            >
              <div
                data-aos="zoom-in"
                data-aos-delay="700"
                className="w-20 h-20 inline-flex items-center justify-center rounded-full bg-[#f9e4b2] text-[#d09714] mb-5 flex-shrink-0 transition-all duration-300 transform hover:scale-110 hover:bg-[#f3d284]"
              >
                <FaBullhorn className="w-10 h-10 text-[#d09714]" />
              </div>

              <div className="flex-grow">
                <h2 data-aos="fade-up" data-aos-delay="800" className="text-[#d09714] text-lg title-font font-medium mb-3">
                  Digital Marketing
                </h2>

                <p data-aos="fade-up" data-aos-delay="900" className="leading-relaxed text-base">
                  Our digital marketing strategies are designed to increase your online visibility.
                </p>

                <button
                  data-aos="fade-up"
                  data-aos-delay="1000"
                  className="mt-3 text-[#d09714] inline-flex items-center"
                  onClick={() => handleScroll(800)}
                >
                  Discover More
                </button>
              </div>
            </div>

          </div>
        </div>
      </section>
      <hr />
    </div>
  );
};

export default Services;